const resumo_de_alunos_marcados = [
  {
    path: "/resumo-de-alunos-marcados",
    name: "resumo_de_alunos_marcados",
    meta: {
      breadCrumb: "Censo Escolar - Marcação de Alunos",
      allowedPermissions: ["marcacao_resumo_alunos_marcados"],
    },
    component: () =>
      import("@/views/ResumoDeAlunosMarcados/ResumoDeAlunosMarcados.vue"),
  },
];

export { resumo_de_alunos_marcados };
